import * as CookieConsent from 'vanilla-cookieconsent';

window.dataLayer = window.dataLayer || [];
function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
}

gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'denied',
});

if (CookieConsent.getCookie('categories', 'cc_cookie')) {
    const acceptedCategories = CookieConsent.getCookie('categories', 'cc_cookie') || [];
    gtag('consent', 'update', {
        functionality_storage: acceptedCategories.includes('functionality') ? 'granted' : 'denied',
        ad_storage: acceptedCategories.includes('marketing') ? 'granted' : 'denied',
        ad_user_data: acceptedCategories.includes('marketing') ? 'granted' : 'denied',
        ad_personalization: acceptedCategories.includes('marketing') ? 'granted' : 'denied',
        analytics_storage: acceptedCategories.includes('analytics') ? 'granted' : 'denied',
        personalization_storage: acceptedCategories.includes('personalization') ? 'granted' : 'denied',
        security_storage: acceptedCategories.includes('security') ? 'granted' : 'denied',
    });
}

function manageConsent() {
    gtag('consent', 'update', {
        functionality_storage: CookieConsent.acceptedCategory('functionality') ? 'granted' : 'denied',
        ad_storage: CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        ad_user_data: CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        ad_personalization: CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        analytics_storage: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        personalization_storage: CookieConsent.acceptedCategory('personalization') ? 'granted' : 'denied',
        security_storage: CookieConsent.acceptedCategory('security') ? 'granted' : 'denied',
    });
}

window.addEventListener('load', () => {
    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */
    CookieConsent.run({
        revision: 1,
        categories: {
            necessary: {
                enabled: true, // this category is enabled by default
                readOnly: true, // this category cannot be disabled
            },
            analytics: {
                autoClear: {
                    cookies: [
                        { name: /^_ga/ },
                        { name: '_gid' },
                        { name: /^__hs/ },
                        { name: 'hubspotutk' },
                        { name: /^_cl(ck|sk)$/ },
                    ],
                },
            },
            marketing: {
                autoClear: {
                    cookies: [{ name: '_fbp' }],
                },
            },
        },

        language: {
            default: 'fr-CA',
            autoDetect: 'document',
            translations: {
                'en-CA': {
                    consentModal: {
                        description:
                            "We place great importance on the protection of your privacy. Our data collection practices are governed by a transparent Privacy Policy. By browsing this site, you consent to the use of cookies and other technologies to enhance your experience and analyze site usage. You have the option to manage your preferences by customizing site or browser settings. You can also adjust your choice at any time by clicking the 'Manage Cookie Preferences' link located in the footer. Please refer to our <a href='/en/privacy-policy/' class='cc-link'>Privacy Policy</a> for more information.",
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage preferences',
                    },
                    preferencesModal: {
                        title: 'Cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Save preferences',
                        closeIconLabel: 'Close modal',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: null,
                                description:
                                    'We use cookies to help you navigate efficiently and perform certain functions. Detailed information about all cookies can be found under each consent category below. <br><br>You can choose to enable or disable these cookies in whole or in part. However, please note that disabling some of them may impact your browsing experience.',
                            },
                            {
                                title: "Necessary cookies <span class='pm__badge'>Always Enabled</span>",
                                description:
                                    "Cookies categorized as 'necessary' are stored on your browser and are essential for the basic functionalities of the site. Crucial for the proper functioning of the site, necessary cookies do not store any personally identifiable information.",
                                linkedCategory: 'necessary',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'cc_cookie',
                                            description:
                                                'Stores your cookie consent preferences so the banner is not shown on every visit.',
                                            domain: window.location.hostname,
                                            expiration: '6 months',
                                        },
                                        {
                                            name: 'PHPSESSID',
                                            description:
                                                'Server session identifier used for the proper functioning of the site.',
                                            domain: window.location.hostname,
                                            expiration: 'Session',
                                        },
                                        {
                                            name: 'pll_language',
                                            description:
                                                'Set by Polylang to remember the language selected by the visitor.',
                                            domain: window.location.hostname,
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '__cf_bm',
                                            description:
                                                "Set by Cloudflare on HubSpot's services to distinguish humans from bots.",
                                            domain: 'hubspot.com, hs-scripts.com, hs-banner.com, hs-analytics.net',
                                            expiration: '30 minutes',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Analytics cookies',
                                description:
                                    'We use third-party cookies to analyze your usage of the site. Analytics cookies provide information about visitor interactions, including the number, bounce rate, traffic source, etc. These cookies will only be stored in your browser with your prior consent.',
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_ga',
                                            description:
                                                "Set by <a href='https://policies.google.com/privacy' target='_blank' rel='noopener'>Google Analytics</a> to distinguish unique visitors by assigning them a randomly generated identifier.",
                                            domain: window.location.hostname,
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '_ga_*',
                                            description:
                                                "Set by <a href='https://policies.google.com/privacy' target='_blank' rel='noopener'>Google Analytics 4</a> to persist the state of the current session.",
                                            domain: window.location.hostname,
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '_gid',
                                            description:
                                                "Set by <a href='https://policies.google.com/privacy' target='_blank' rel='noopener'>Google Analytics</a> to anonymously record how visitors use the site.",
                                            domain: window.location.hostname,
                                            expiration: '1 day',
                                        },
                                        {
                                            name: '__hstc',
                                            description:
                                                'Main HubSpot analytics cookie. Tracks visits to the site, recording the timestamp of the first visit, the previous visit and the current visit.',
                                            domain: window.location.hostname,
                                            expiration: '6 months',
                                        },
                                        {
                                            name: 'hubspotutk',
                                            description:
                                                'Set by HubSpot to keep track of a visitor identity. It is passed along with form submissions and used to de-duplicate contacts.',
                                            domain: window.location.hostname,
                                            expiration: '6 months',
                                        },
                                        {
                                            name: '__hssc',
                                            description:
                                                'Set by HubSpot to track sessions, in order to determine whether the session count should change.',
                                            domain: window.location.hostname,
                                            expiration: '30 minutes',
                                        },
                                        {
                                            name: '__hssrc',
                                            description:
                                                'Set by HubSpot to determine whether the visitor has restarted their browser.',
                                            domain: window.location.hostname,
                                            expiration: 'Session',
                                        },
                                        {
                                            name: '_clck',
                                            description:
                                                "Set by <a href='https://privacy.microsoft.com/privacystatement' target='_blank' rel='noopener'>Microsoft Clarity</a> to store a unique user identifier and persist it across visits.",
                                            domain: window.location.hostname,
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '_clsk',
                                            description:
                                                "Set by <a href='https://privacy.microsoft.com/privacystatement' target='_blank' rel='noopener'>Microsoft Clarity</a> to group a user's page views into a single session recording.",
                                            domain: window.location.hostname,
                                            expiration: '1 day',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Marketing cookies',
                                description:
                                    'We use third-party cookies to measure the effectiveness of our advertising campaigns and to show you relevant ads on other platforms. These cookies will only be stored in your browser with your prior consent.',
                                linkedCategory: 'marketing',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_fbp',
                                            description:
                                                "Set by <a href='https://www.facebook.com/privacy/policy/' target='_blank' rel='noopener'>Meta Pixel</a> to identify visitors in order to measure and optimize advertising campaigns.",
                                            domain: window.location.hostname,
                                            expiration: '3 months',
                                        },
                                        {
                                            name: 'fr',
                                            description:
                                                "Set by <a href='https://www.facebook.com/privacy/policy/' target='_blank' rel='noopener'>Meta</a> to deliver, measure and improve the relevance of ads.",
                                            domain: 'facebook.com',
                                            expiration: '3 months',
                                        },
                                        {
                                            name: 'MUID',
                                            description:
                                                "Set by <a href='https://privacy.microsoft.com/privacystatement' target='_blank' rel='noopener'>Microsoft Clarity</a> to identify unique browsers across Microsoft sites.",
                                            domain: 'clarity.ms, bing.com',
                                            expiration: '1 year',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'More information',
                                description:
                                    "For more information, please refer to our <a class='cc-link' href='/en/privacy-policy/'>Privacy Policy</a>.",
                            },
                        ],
                    },
                },
                'fr-CA': {
                    consentModal: {
                        description:
                            "Nous attachons une grande importance à la protection de votre vie privée. Nos pratiques de collecte de données sont régies par une Politique de confidentialité transparente. En naviguant sur ce site, vous consentez à l'utilisation de témoins (cookies) et d'autres technologies pour améliorer votre expérience et analyser l'utilisation du site. Vous avez la possibilité de gérer vos préférences en personnalisant les paramètres du site ou de votre navigateur. Vous pouvez également ajuster votre choix à tout moment en cliquant sur le lien 'Gestion des témoins de navigation', situé dans le pied de page. Consultez notre <a href='/politique-de-confidentialite/' class='cc-link'>Politique de confidentialité</a> pour plus d'informations.",
                        acceptAllBtn: 'Tout accepter',
                        acceptNecessaryBtn: 'Tout rejeter',
                        showPreferencesBtn: 'Gérer les préférences',
                    },
                    preferencesModal: {
                        title: 'Personnaliser vos préférences en matière de consentement',
                        acceptAllBtn: 'Tout accepter',
                        acceptNecessaryBtn: 'Tout rejeter',
                        savePreferencesBtn: 'Sauvegarder les préférences',
                        closeIconLabel: 'Fermer la modale',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: null,
                                description:
                                    "Nous utilisons des témoins (cookies) pour vous aider à naviguer efficacement et à exécuter certaines fonctionnalités. Vous trouverez des informations détaillées sur tous les cookies sous chaque catégorie de consentement ci-dessous. <br><br>Vous pouvez choisir d'activer tout ou de désactiver en partie ces témoins. Toutefois, veuillez noter que la désactivation de certains d'entre eux pourrait avoir un impact sur votre expérience de navigation. ",
                            },
                            {
                                title: "Témoins (cookies) nécessaires <span class='pm__badge'>Toujours activés</span>",
                                description:
                                    "Les témoins catégorisés comme 'nécessaires' sont stockés sur votre navigateur et sont essentiels pour les fonctionnalités de base du site. Cruciaux pour le bon fonctionnement du site, les témoins nécessaires ne stockent aucune donnée personnellement identifiable.",
                                linkedCategory: 'necessary',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'cc_cookie',
                                            description:
                                                'Enregistre vos préférences de consentement afin que le bandeau ne soit pas affiché à chaque visite.',
                                            domain: window.location.hostname,
                                            expiration: '6 mois',
                                        },
                                        {
                                            name: 'PHPSESSID',
                                            description:
                                                'Identifiant de session du serveur utilisé pour le bon fonctionnement du site.',
                                            domain: window.location.hostname,
                                            expiration: 'Session',
                                        },
                                        {
                                            name: 'pll_language',
                                            description:
                                                'Déposé par Polylang pour mémoriser la langue choisie par le visiteur.',
                                            domain: window.location.hostname,
                                            expiration: '1 an',
                                        },
                                        {
                                            name: '__cf_bm',
                                            description:
                                                'Déposé par Cloudflare sur les services de HubSpot pour distinguer les humains des robots.',
                                            domain: 'hubspot.com, hs-scripts.com, hs-banner.com, hs-analytics.net',
                                            expiration: '30 minutes',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Témoins (cookies) analytiques',
                                description:
                                    "Nous utilisons des témoins tiers pour analyser votre utilisation du site. Les témoins d’analytique fournissent des informations sur les interactions des visiteurs, notamment le nombre, le taux de rebond, la source de trafic, etc. Ces témoins ne seront stockés dans votre navigateur qu'avec votre consentement préalable.",
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_ga',
                                            description:
                                                "Déposé par <a href='https://policies.google.com/privacy' target='_blank' rel='noopener'>Google Analytics</a> pour distinguer les visiteurs uniques en leur attribuant un identifiant généré aléatoirement.",
                                            domain: window.location.hostname,
                                            expiration: '2 ans',
                                        },
                                        {
                                            name: '_ga_*',
                                            description:
                                                "Déposé par <a href='https://policies.google.com/privacy' target='_blank' rel='noopener'>Google Analytics 4</a> pour conserver l'état de la session en cours.",
                                            domain: window.location.hostname,
                                            expiration: '2 ans',
                                        },
                                        {
                                            name: '_gid',
                                            description:
                                                "Déposé par <a href='https://policies.google.com/privacy' target='_blank' rel='noopener'>Google Analytics</a> pour enregistrer de façon anonyme l'utilisation du site par les visiteurs.",
                                            domain: window.location.hostname,
                                            expiration: '1 jour',
                                        },
                                        {
                                            name: '__hstc',
                                            description:
                                                'Principal témoin analytique de HubSpot. Suit les visites sur le site en enregistrant la date de la première visite, de la précédente et de la visite en cours.',
                                            domain: window.location.hostname,
                                            expiration: '6 mois',
                                        },
                                        {
                                            name: 'hubspotutk',
                                            description:
                                                "Déposé par HubSpot pour suivre l'identité du visiteur. Il est transmis lors de l'envoi des formulaires et sert à éviter les doublons de contacts.",
                                            domain: window.location.hostname,
                                            expiration: '6 mois',
                                        },
                                        {
                                            name: '__hssc',
                                            description:
                                                'Déposé par HubSpot pour suivre les sessions et déterminer si le nombre de sessions doit être incrémenté.',
                                            domain: window.location.hostname,
                                            expiration: '30 minutes',
                                        },
                                        {
                                            name: '__hssrc',
                                            description:
                                                'Déposé par HubSpot pour déterminer si le visiteur a redémarré son navigateur.',
                                            domain: window.location.hostname,
                                            expiration: 'Session',
                                        },
                                        {
                                            name: '_clck',
                                            description:
                                                "Déposé par <a href='https://privacy.microsoft.com/fr-ca/privacystatement' target='_blank' rel='noopener'>Microsoft Clarity</a> pour conserver un identifiant unique d'utilisateur d'une visite à l'autre.",
                                            domain: window.location.hostname,
                                            expiration: '1 an',
                                        },
                                        {
                                            name: '_clsk',
                                            description:
                                                "Déposé par <a href='https://privacy.microsoft.com/fr-ca/privacystatement' target='_blank' rel='noopener'>Microsoft Clarity</a> pour regrouper les pages vues d'un utilisateur en un seul enregistrement de session.",
                                            domain: window.location.hostname,
                                            expiration: '1 jour',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Témoins (cookies) marketing',
                                description:
                                    "Nous utilisons des témoins tiers pour mesurer l'efficacité de nos campagnes publicitaires et vous présenter des publicités pertinentes sur d'autres plateformes. Ces témoins ne seront stockés dans votre navigateur qu'avec votre consentement préalable.",
                                linkedCategory: 'marketing',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_fbp',
                                            description:
                                                "Déposé par <a href='https://www.facebook.com/privacy/policy/' target='_blank' rel='noopener'>Meta Pixel</a> pour identifier les visiteurs afin de mesurer et d'optimiser les campagnes publicitaires.",
                                            domain: window.location.hostname,
                                            expiration: '3 mois',
                                        },
                                        {
                                            name: 'fr',
                                            description:
                                                "Déposé par <a href='https://www.facebook.com/privacy/policy/' target='_blank' rel='noopener'>Meta</a> pour diffuser des publicités, en mesurer la performance et en améliorer la pertinence.",
                                            domain: 'facebook.com',
                                            expiration: '3 mois',
                                        },
                                        {
                                            name: 'MUID',
                                            description:
                                                "Déposé par <a href='https://privacy.microsoft.com/fr-ca/privacystatement' target='_blank' rel='noopener'>Microsoft Clarity</a> pour identifier les navigateurs uniques sur les sites de Microsoft.",
                                            domain: 'clarity.ms, bing.com',
                                            expiration: '1 an',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Pour en savoir plus',
                                description:
                                    "Pour plus d’information, consultez notre <a class='cc-link' href='/politique-de-confidentialite/'>Politique de confidentialité</a>.",
                            },
                        ],
                    },
                },
            },
        },

        onFirstConsent: (...args) => {
            manageConsent(args);
            window.dataLayer.push({ event: 'consent_ready' });
        },
        onChange: (...args) => {
            manageConsent(args);
            window.dataLayer.push({ event: 'consent_update' });
        },
    });
});
